import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
} from '@material-ui/core';

const TicketSelector = ({ ...props }) => {
  const { tickets, onSelect } = props;
  const [selectedTicket, setSelectedTicket] = useState('');

  const handleChange = (event) => {
    setSelectedTicket(event.target.value);
    onSelect(event.target.value);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">
        Selecciona la solicitud que quieres revisar:
      </FormLabel>
      <RadioGroup value={selectedTicket} onChange={handleChange}>
        {tickets.map((ticket, index) => (
          <FormControlLabel
            disabled
            key={index}
            value={String(ticket.id)}
            control={<Radio color="primary" />}
            label={`Solicitud ${ticket.id}: ${ticket.motiveName}`}
            data-cy={`ticketSelector-${index}`}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

TicketSelector.propTypes = {
  tickets: PropTypes.array,
  onSelect: PropTypes.func,
};

export default TicketSelector;
